module.exports = __webpack_public_path__ + "static/pexels-6-a963b6d580ba08b6e0f4adf6b62d942c.png";